import { get, set, remove } from '../services/storage.service';

/******************* CHECK *************************************
See if there is a Mindset saved and if there is show the load button */
export async function checkMindset(){
    let data = "none";
    await get('mindset'
    ).then(function (finalResult){
            const mindD = JSON.parse(finalResult);
            if(mindD.level !== "" || mindD.level === null){
                data = "found";
            }else{
                data = "none";
            }
            //DEBUG - console.log(finalResult);
        }).catch(err => {
            console.log("e: " + err.message);
            data = "none";
        }
    );
console.log(data);
    return data;
}
/******************* SAVE *************************************
Saves the data to the local device - whether they are done or not
or for use in case they don't have internet at the time */

export async function saveMindset(
        savelevel:any,
        savemindset:any,
        savecuriositycheck:boolean,
        savecuriosity:any,
        savecuricon:any,
        saveempowermentcheck:boolean,
        saveempowerment:any,
        saveempicon:any,
        saveresponsibilitycheck:boolean,
        saveresponsibility:any,
        saveresicon:any,
        saveobservation:any, 
        saveobsicon:any,
        savecommunication:any, 
        savecomicon:any,
        savecollaboration:any, 
        savecolicon:any,
        saveproblemsolving:any,
        saveproicon:any,
        savefirstname:any,
        //savelastname:any,
        saveexptitle:any,
        savewonderawechecked:any,
        savewonderawe:any,
        saveadventurousnesschecked:any,
        saveadventurousness:any,
        saverespectchecked:any,
        saverespect:any,
        saveempathychecked:any,
        saveempathy:any,
        savegritchecked:any,
        savegrit:any,
        saveadaptabilitychecked:any,
        saveadaptability:any,
        savegrowthmindsetchecked:any,
        savegrowthmindset:any,
        savefocuschecked:any,
        savefocus:any,
        savedatacollectingchecked:any,
        savedatacollecting:any,
        savereasoningchecked:any,
        savereasoning:any,
        savecreativitychecked:any,
        savecreativity:any,
): Promise<void>{
    set ("mindset",JSON.stringify({ 
        "level":savelevel, 
        "mindset":savemindset,
        "curiositycheck": savecuriositycheck,
        "curiosity": savecuriosity, 
        "curiosityicon": savecuricon,
        "responsibilitycheck": saveresponsibilitycheck,
        "responsibility": saveresponsibility,
        "responsibilityicon" : saveresicon,
        "empowermentcheck": saveempowermentcheck,
        "empowerment": saveempowerment,
        "empowermenticon":saveempicon,
        "observation": saveobservation,
        "observationicon":saveobsicon,
        "communication": savecommunication,
        "communcationicon": savecomicon,
        "collaboration": savecollaboration,
        "collaborationicon": savecolicon,
        "problemsolving": saveproblemsolving,
        "problemsolvingicon": saveproicon,
        "firstname": savefirstname, 
        //"lastname": savelastname, 
        "exptitle": saveexptitle,
        'wonderawecheck': savewonderawechecked,
        'wonderawe': savewonderawe,
        'adventurousnesscheck': saveadventurousnesschecked,
        'adventurousness': saveadventurousness,
        'respectcheck': saverespectchecked,
        'respect': saverespect,
        'empathycheck': saveempathychecked,
        'empathy': saveempathy,
        'gritcheck': savegritchecked,
        'grit': savegrit,
        'adaptabilitycheck': saveadaptabilitychecked,
        'adaptability': saveadaptability,
        'growthmindsetcheck': savegrowthmindsetchecked,
        'growthmindset': savegrowthmindset, 
        'focuscheck': savefocuschecked,
        'focus': savefocus,
        'datacollectingcheck': savedatacollectingchecked,
        'datacollecting': savedatacollecting,
        'reasoningcheck': savereasoningchecked,
        'reasoning': savereasoning,
        'creativitycheck': savecreativitychecked,
        'creativity': savecreativity
    })
    ).then(function (finalResult) {
        console.log("saved mindset");
        console.log(finalResult);
        return true;
    }).catch(err => {
        console.log("e: " + err.message);
        return false;
    }
    );
}
/******************* LOAD *************************************
Load your saved mindset to take over the current form */
export async function loadMindset(){
    //some stuff
    console.log("load mindset");
    let data = "";
    await get('mindset'
        ).then(function (finalResult){
            const mindD = finalResult;
            data = mindD; //DEBUG - console.log(mindD.level);
        }).catch(err => { //DEBUG - console.log("e: " + err.message);
            data = err.message;
        }
    );
    return data;
}
/******************* REMOVE *************************************
If the form is sent to the server remove the local version of it. */
export async function removeMindset(): Promise<void> {
    remove('mindset'
    ).then(function (finalResult){
        //console.log('remove');
    }).catch(err => {
        //console.log("e: " + err.message);
    }
    );
}